import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 0.6rem !important;

  div {
    color: #808080;
    border: 1px solid #808080;
    border-radius: 0.4rem;
    padding: 1rem;
    font-weight: 700;
    font-size: 0.6rem;
    text-align: center;
  }

  @media (max-width: 1480px) {
    padding: 0 1rem;
  }
`;
